module.exports = __webpack_public_path__ + "img/ep-soleil.a38f1c05.jpg";